import { render, staticRenderFns } from "./noItem.vue?vue&type=template&id=34e8772c&"
import script from "./noItem.vue?vue&type=script&lang=js&"
export * from "./noItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports